module.exports = __webpack_public_path__ + "img/prize-02.b43a7b85.png";